import { render } from "./upload_widget.vue?vue&type=template&id=0f3bcab4&scoped=true"
import script from "./upload_widget.vue?vue&type=script&lang=js"
export * from "./upload_widget.vue?vue&type=script&lang=js"

import "./upload_widget.vue?vue&type=style&index=0&id=0f3bcab4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3bcab4"]])

export default __exports__